module.exports = __webpack_public_path__ + "static/img/10005 (2).eddef67.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10005 (2).webp
// module id = OeZp
// module chunks = 14